import { useCallback } from "react";

import useAssistantPanelStore from "components/AssistantPanel/Layout/useStore";
import { AssistantPanelView } from "components/AssistantPanel/Layout/types";
import useAssistantPanelLearnStore from "components/AssistantPanel/Learn/useStore";

const useOpenLearnGuide = () => {
  const { setNavigationState } = useAssistantPanelLearnStore();
  const { setIsOpen, switchView } = useAssistantPanelStore();

  return useCallback(
    (groupId: string) => {
      setIsOpen(true);
      switchView(AssistantPanelView.LEARN);
      setNavigationState({ level: "guide", groupId });
    },
    [setIsOpen, switchView, setNavigationState]
  );
};

export default useOpenLearnGuide;
